export default "__VITE_ASSET__fcec0313__"